import type { RootState } from 'src/app/store';
import { store } from 'src/app/store';

import {
  areaSelected,
  getIdOfAreaIndex,
  getIdOfPointIndex,
  getIndexOfArea,
  pointSelected,
  selectCurrentAreaId,
  selectCurrentAreaIndex,
  selectCurrentPointId,
  selectCurrentPointIndex,
  selectLoaderComplete,
  selectPreventNavigation,
  selectSoundEnabled,
  invertColors,
} from 'src/state';

const down = 'ArrowDown';
const up = 'ArrowUp';
const left = 'ArrowLeft';
const right = 'ArrowRight';
const space = ' ';

document.addEventListener('keydown', onKey);

let state: RootState = store.getState();
let previousAreaId = state.navigation.currentAreaId;
let previousAreaIndex = getIndexOfArea(previousAreaId, state);
let previousPointId: string | undefined | null;
let previousPointIndex = -1;
let preventNavigation = selectPreventNavigation(state);
let isSoundEnabled = selectSoundEnabled(state);
let loadingComplete = selectLoaderComplete(state);

store.subscribe(() => {
  state = store.getState();
  const currentAreaId = selectCurrentAreaId(state);
  if (previousAreaId !== currentAreaId) {
    setCurrentAreaIndex();
    previousAreaId = currentAreaId;
  }

  const currentPointId = selectCurrentPointId(state);
  if (previousPointId !== currentPointId) {
    setCurrentPointIndex();
    previousPointId = currentPointId;
  }

  preventNavigation = selectPreventNavigation(state);
  isSoundEnabled = selectSoundEnabled(state);
  loadingComplete = selectLoaderComplete(state);
});

function setCurrentAreaIndex() {
  previousAreaIndex = selectCurrentAreaIndex(state);
}

function setCurrentPointIndex() {
  previousPointIndex = selectCurrentPointIndex(state);
}

function onKey(e: KeyboardEvent) {
  if (preventNavigation) return;
  if (!isSoundEnabled) return;
  if (!loadingComplete) return;

  const { key } = e;

  if (key === down && previousAreaId) {
    onDownKeyPress();
  } else if (key === up && previousAreaId) {
    onUpKeyPress();
  } else if (key === left) {
    onLeftKeyPress();
  } else if (key === right) {
    onRightKeyPress();
  } else if (key === space) {
    store.dispatch(invertColors());
  }
}

export function onLeftKeyPress() {
  const newAreaId = getIdOfAreaIndex(previousAreaIndex - 1, state);
  if (newAreaId) store.dispatch(areaSelected(newAreaId));
}

export function onRightKeyPress() {
  const newAreaId = getIdOfAreaIndex(previousAreaIndex + 1, state);
  if (newAreaId) store.dispatch(areaSelected(newAreaId));
}

export function onUpKeyPress() {
  const newPointId = getIdOfPointIndex(previousAreaId, previousPointIndex + 1, state);
  store.dispatch(pointSelected(newPointId));
}

export function onDownKeyPress() {
  const newPointId = getIdOfPointIndex(previousAreaId, previousPointIndex - 1, state);
  store.dispatch(pointSelected(newPointId));
}
